import React from 'react';
import { Sun, Clock } from 'lucide-react';
import { safeFormat } from '../../utils/timeFormatters';

const SpecialTimesPanel = ({ additionalInfo, coordinates, timezone }) => {
  if (!additionalInfo) return null;

  // Use IANA timezone for accurate formatting
  const formatTimeForLocation = (date) => {
    return safeFormat(date, coordinates, timezone);
  };
  
  return (
    <div>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="flex items-center">
          <Sun size={14} className="text-yellow-400 mr-1" />
          <span className="text-white/70">Solar Noon:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.solarNoon)}
        </span>
        
        <div className="flex items-center">
          <span className="text-amber-300 mr-1">✨</span>
          <span className="text-white/70">Golden Hour:</span>
        </div>
        <span className="text-white">
          {additionalInfo?.goldenHour ? 
            `${formatTimeForLocation(additionalInfo.goldenHour.start)} - ${formatTimeForLocation(additionalInfo.goldenHour.end)}` : 
            'N/A'}
        </span>
        
        <div className="flex items-center">
          <span className="text-blue-300 mr-1">✨</span>
          <span className="text-white/70">Blue Hour:</span>
        </div>
        <span className="text-white">
          {additionalInfo?.blueHour ? 
            `${formatTimeForLocation(additionalInfo.blueHour.start)} - ${formatTimeForLocation(additionalInfo.blueHour.end)}` : 
            'N/A'}
        </span>
        
        <div className="flex items-center">
          <Clock size={14} className="text-white mr-1" />
          <span className="text-white/70">Day Length:</span>
        </div>
        <span className="text-white">
          {additionalInfo?.dayLength ? 
            `${Math.floor(additionalInfo.dayLength / 3600)}h ${Math.floor((additionalInfo.dayLength % 3600) / 60)}m` : 
            'N/A'}
        </span>
      </div>
    </div>
  );
};

export default SpecialTimesPanel;